import { render, staticRenderFns } from "./CursoVersionHeader.vue?vue&type=template&id=cfc1dbee&"
import script from "./CursoVersionHeader.vue?vue&type=script&lang=js&"
export * from "./CursoVersionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports